import { Paper, Table, TableContainer } from '@mui/material'
import CommissionTableHeader from './commission-table-header/commission-table-header'
import CommissionTableBody from './commission-table-body/commission-table-body'
import { CommissionResponse } from 'store/commissions/commissions.types'

interface CommissionTableProps {
  commissions: CommissionResponse[]
}

const CommissionTable = ({ commissions }: CommissionTableProps) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
      <Table aria-label="commission table">
        <CommissionTableHeader />
        <CommissionTableBody commissions={commissions} />
      </Table>
    </TableContainer>
  )
}

export default CommissionTable

